<template>
    <div :class="classes">
        <div class="drawer-accordion__head" @click="handleClick">
            <CompassIcon
                icon="caret-right-fill"
                size="extra-small"
                class="drawer-accordion__caret"
            />

            <p class="drawer-accordion__title typographies-paragraph-caps-small-bold">
                {{ title }}
            </p>
            <slot name="action" />
        </div>

        <div class="drawer-accordion__content" ref="accordionContent" :style="contentMaxHeight">
            <div class="drawer-accordion__content-wrapper" ref="accordionContentWrapper">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import LocalStorage from 'Core/commons/LocalStorage';

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            localstorage: new LocalStorage('drawer-accordion', 'overview'),
            isOpen: true,
            contentHeight: 0,
            observer: null,
        };
    },
    computed: {
        classes() {
            return ['drawer-accordion', this.isOpen ? 'drawer-accordion--open' : ''];
        },
        contentMaxHeight() {
            return `max-height: ${this.isOpen ? this.contentHeight : 0}px;`;
        },
    },
    mounted() {
        this.isOpen = this.localstorage.get()?.[this.id] ?? true;
        this.initObserver();
        setTimeout(() => {
            this.setContentHeight();
        }, 0);
    },
    beforeDestroy() {
        if (this.observer) this.observer.unobserve(this.$refs.accordionContentWrapper);
    },
    methods: {
        initObserver() {
            const observer = new ResizeObserver(this.setContentHeight);
            observer.observe(this.$refs.accordionContentWrapper);
            this.observer = observer;
        },
        setContentHeight() {
            this.contentHeight = this.$refs.accordionContent.scrollHeight;
        },
        handleClick() {
            this.isOpen = !this.isOpen;
            const storedValues = this.localstorage.get() ?? {};
            storedValues[this.id] = this.isOpen;
            this.localstorage.set({ ...storedValues });
        },
    },
};
</script>

<style lang="scss" scoped>
.drawer-accordion {
    border-bottom: 1px solid var(--colors-common-border-lighter);

    &__head {
        align-items: center;
        cursor: pointer;
        display: flex;
        gap: var(--spacing-0);
        padding: var(--spacing-3) var(--spacing-2);
        position: relative;
        transition: all 200ms ease-in-out;
        z-index: 1;

        &:hover {
            background: var(--colors-common-background-hover);
        }
    }

    &--open {
        .drawer-accordion__caret {
            transform: rotate(90deg);
        }
    }

    &__caret {
        flex-shrink: 0;
        transition: all 200ms ease-in-out;
    }

    &__title {
        flex: 1;
        margin: 0;

        + * {
            flex-shrink: 0;
        }
    }

    &__content {
        max-height: 0;
        overflow: hidden;
        transition: all 200ms ease-in-out;

        &-wrapper {
            padding: var(--spacing-1) var(--spacing-2) var(--spacing-3) var(--spacing-2);
        }
    }
}
</style>
